import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logoutThunk } from '@/redux/userSlice'
import type { AppDispatch } from '@/store'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

const NoOrganization = () => {
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await dispatch(logoutThunk())
    navigate('/signin')
  }

  return (
    <div className="flex min-h-screen items-center justify-center py-8 relative">
      <div className="fixed inset-0 -z-10 bg-[#F4F7EF]" />

      <div className="w-full max-w-md px-4">
        <Card className="rounded-[28px] border-0 bg-[#FFFFFF] py-4 shadow-[0_20px_60px_rgba(16,24,40,0.08)] sm:px-4">
          <CardHeader className="text-center pb-0">
            <div className="flex justify-center mb-4">
              <img
                src="https://adthlete.us-iad-1.linodeobjects.com/public/adthlete_logomark.png"
                alt="Athios Logo"
                className="w-10 h-10"
              />
            </div>
            <CardTitle className="text-2xl font-black text-[#0F172A] tracking-tight">
              No Organization Found
            </CardTitle>
            <CardDescription className="mt-2 text-[#4B5563]">
              Your account is not linked to an organization yet.
            </CardDescription>
          </CardHeader>

          <CardContent className="pt-6 space-y-6">
            <div className="bg-[#C0FD72]/10 border border-[#C0FD72]/20 rounded-lg p-4 text-sm text-[#374151] space-y-2">
              <p>
                All marketer accounts must belong to an organization. You can join one by accepting
                an invitation sent by an organization admin.
              </p>
              <p>
                If you believe this is a mistake, please contact{' '}
                <a
                  href="mailto:support@adthlete.us"
                  className="text-[#3F7A0A] hover:text-[#3F7A0A] underline"
                >
                  support@adthlete.us
                </a>
                .
              </p>
            </div>

            <div className="space-y-3">
              <p className="text-[#4B5563] text-sm text-center">
                Already have an invitation link? Open it in your browser to join your organization.
              </p>

              <Button
                variant="outline"
                className="w-full bg-[#F9FAFB] border-[#E5E7EB] text-[#0F172A] hover:bg-[#F3F4F6]"
                onClick={handleLogout}
              >
                Sign Out
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default NoOrganization
